const dropDown = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    flexWrap: "nowrap",
    border: "none",
    borderRadius: "3px",
    padding: "0.55rem 1rem",
    width: "100%",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    border: "1px solid #868E96",
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isFocused && !state.isSelected ? "#FFFF" : null,
    ":active": {
      backgroundColor: "#FFFF",
    },
    backgroundColor: state.isSelected ? "white" : "white",
    color: " black",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      cursor: "pointer",
      fontSize: "14px",
      color: "#495057",
    };
  },
};

const appointmentDropDown = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "0.875rem",
    border: "1px solid #40c057",
    borderRadius: "3px",
    padding: "0px 0.2rem",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "600",
    boxShadow: "0",
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Arial, Helvetica, sans-serif",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#40c057"
      : state.isFocused
        ? "#40c05730"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#40c05730" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#B0B5B9",
    };
  },
  singleValue: provided => ({
    ...provided,
    //  textOverflow:"unset",
     textOverflow: "ellipsis",
     width:"fit-content"
    
    
  })
};

const appointmentDropDownBig = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    border: "1px solid #40c057",
    borderRadius: "3px",
    padding: "0px 0.2rem",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    height: "50px",
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#ff4848"
      : state.isFocused
        ? "#ffc9c9"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#ffc9c9" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#B0B5B9",
    };
  },
  singleValue: provided => ({
    ...provided,
    color: '#343A40',
    opacity: "0.8"
  })
};

const dopDownMenuOut = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    borderRadius: "3px",
    padding: "0px 0.2rem",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    border: state.isFocused ? "1px solid #868E96" : "1px solid #ced4da",
    "&:hover": {
      border: state.isFocused ? "1px solid #868E96" : "1px solid #ced4da",
    }
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#ff4848"
      : state.isFocused
        ? "#ffc9c9"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#ffc9c9" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#B0B5B9",
    };
  },
  menuPortal: base => ({ ...base, zIndex: 9999 })
};

const smallDropDown = {
  control: (styles, state) => ({
    ...styles,
    height: "2rem",
    color: "#495057",
    fontSize: "0.875rem",
    flexWrap: "nowrap",
    border: "1px solid #42ba85",
    borderRadius: "3px",
    padding: "0.5rem 0.5rem",
    width: "100%",
    fontFamily: "app-font-medium",
    boxShadow: "0",
    '&:hover': {
      borderColor: '#42ba85',
    },
    '@media (max-width: 768px)': {
      // fontSize: "0.75rem",
      padding: "0.5rem 0rem",
      // height: "1.5rem",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "app-font-regular",
    fontSize: "0.875rem",
    backgroundColor: state.isSelected
      ? "#42ba85"
      : state.isFocused
        ? "#42ba8530"
        : "white",
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontFamily: "app-font-regular",
      fontSize: "0.875rem",
      color: "#343A40",
    };
  },
};
// const languageDropDown = {
//   control: (styles, state) => ({
//     ...styles,
//     height: "38px",
//     color: "#495057",
//     fontSize: "0.875rem",
//     flexWrap: "nowrap",
//     border: "none",
//     borderRadius: "3px",
//     fontFamily: "app-font-medium",
//     boxShadow: "0",
//   }),
//   option: (provided, state) => ({
//     ...provided,
//     fontFamily: "app-font-regular",
//     fontSize: "0.875rem",
//     backgroundColor: state.isSelected
//       ? "#42ba85"
//       : state.isFocused
//       ? "#42ba8530"
//       : "white",
//   }),

//   menu: (styles) => ({
//     ...styles,
//     backgroundColor: "#ffffff",
//     borderRadius: "100px",
//     boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
//     marginTop: "5px",
//     zIndex: 1,
//   }),

//   valueContainer: (provided) => ({
//     ...provided,
//     display: "none",
//   }),
//   menu: (provided) => ({
//     ...provided,
//     width: "130px",
//     right: "3%",
//   }),
//   indicatorSeparator: (styles) => ({ display: "none" }),
//   placeholder: (provided, state) => ({
//     ...provided,
//     display: "none",
//   }),
// };


const languageDropDown = {
  control: (styles, state) => ({
    ...styles,
    height: "38px",
    color: "#495057",
    fontSize: "0.875rem",
    flexWrap: "nowrap",
    border: "none",
    borderRadius: "3px",
    fontFamily: "app-font-medium",
    boxShadow: "0",
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "app-font-regular",
    fontSize: "0.875rem",
    backgroundColor: state.isSelected
      ? "#42ba85"
      : state.isFocused
        ? "#42ba8530"
        : "white",
  }),

  menu: (styles) => ({
    ...styles,
    backgroundColor: "#ffffff",
    borderRadius: "100px",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    marginTop: "5px",
    zIndex: 1,
  }),

  valueContainer: (provided) => ({
    ...provided,
    display: "none",
  }),
  menu: (provided) => ({
    ...provided,
    width: "130px",
    right: "3%"
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (provided, state) => ({
    ...provided,
    display: 'none'
  })
};

const switchStyle = {
  uncheckedIcon: false,
  checkedIcon: false,
  handleDiameter: 12,
  height: 18,
  width: 36,
  offHandleColor: "#42ba86",
  onHandleColor: "#42ba86",
  offColor: `#d8e6e0`,
  onColor: `#d8e6e0`,
  activeBoxShadow: "0px 0px 1px 1px rgba(0, 0, 0, 0.2)",
};

const selectDropDownPrimary = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "0.875rem",
    flexWrap: "nowrap",
    borderRadius: "3px",
    padding: "0.55rem 0.55rem",
    cursor: "pointer",
    width: "100%",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "600",
    boxShadow: "0",
    borderColor: "#42ba85",
    border: state.isFocused ? "1px solid #42ba85" : "1px solid #ffff",
    "&:hover": {
      border: state.isFocused ? "1px solid #42ba85" : "1px solid #ffff",
    }
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#42ba85"
      : state.isFocused
        ? "#42ba8530"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#42ba8530" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#343A40",
      opacity: "0.7",
    };
  },
};

const selectDropDownPrimaryNoBackground = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "0.875rem",
    flexWrap: "nowrap",
    border: "none",
    borderRadius: "3px",
    padding: "0.55rem 0.55rem",
    width: "100%",
    fontFamily: "Arial, Helvetica, sans-serif",
    fontWeight: "600",
    boxShadow: "0",
    border: state.isFocused ? "1px solid #42ba85" : "1px solid #ffff",
    "&:hover": {
      border: state.isFocused ? "1px solid #42ba85" : "1px solid #ffff",
    }
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isFocused && !state.isSelected ? "#FFFF" : null,
    ":active": {
      backgroundColor: "#FFFF",
    },
    color: "black",
  }),
  indicatorSeparator: (provided) => ({
    ...provided,
    backgroundColor: "#fff",
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      cursor: "pointer",
      fontSize: "14px",
      color: "#495057",
      opacity:0.7,
    };
  },
 
  menu: (provided, state) => ({
    ...provided,
    zIndex: 9999, 
  }),
  menuList: (provided, state) => ({
    ...provided,
    padding: 0, 
  
  }),
};

const selectDropDown = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    flexWrap: "nowrap",
    border: "none",
    borderRadius: "3px",
    padding: "0rem 1rem",
    cursor: "pointer",
    width: "100%",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    borderColor: "#ff4848",
    border: state.isFocused ? "1px solid #868E96" : 0,
    "&:hover": {
      border: state.isFocused ? "1px solid #868E96" : 0,
    },
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#ff4848"
      : state.isFocused
        ? "#ffc9c9"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#ffc9c9" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#495057",
    };
  },
};

const customDropDownStyles = {
  control: (provided, state) => ({
    ...provided,
    fontSize: '14px',
    height: '38px',
    display: 'flex',
    zIndex: '1',
    width: '100%',
    cursor: "pointer",
    flexWrap: "nowrap",
    color: 'var(--primary-color)',
    borderColor: state.isFocused ? 'var(--primary-color)' : '',
    fontWeight: 'normal',
    backgroundColor: '#FFF',
    boxShadow: "none",
    ':hover': {
      borderColor: 'var(--primary-color)',
    },
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#effdf7"
      : state.isFocused
        ? "#effdf7"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#effdf7" : 0,
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  menu: (provided) => ({
    ...provided,
    width: "150px",
    right: "3%"
  }),
};

const color = {
  vitalColorOption1: '#FF4848',
  vitalColorOption2: "#37b24d",
  vitalAverageColor: "#FFE8CC",
  vitalMinimumColor: "#D0EBFF",
  vitalMaximumColor: "#FFE3E3",
  primaryColor: "#ff4848",
}

const reportDropDown = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    border: 'none',
    padding: "0px 0.2rem",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    cursor: 'pointer'
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    color:"grey",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#CCFFBB"
      : state.isFocused
        ? "#CCFFBB"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#CCFFBB" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#000",
    };
  },

};
const reportDropDowntwo = {
  control: (styles, state) => ({
    ...styles,
    color: "#495057",
    fontSize: "14px",
    border: 'none',
    padding: "0px 0.2rem",
    fontFamily: "Avenir Next LT Pro",
    fontWeight: "600",
    boxShadow: "0",
    cursor: 'pointer'
  }),
  option: (provided, state) => ({
    ...provided,
    fontFamily: "Avenir Next LT Pro",
    fontSize: "14px",
    fontWeight: "600",
    color:"grey",
    cursor: "pointer",
    backgroundColor: state.isSelected
      ? "#CCFFBB"
      : state.isFocused
        ? "#CCFFBB"
        : "white",
    "&:hover": {
      backgroundColor: state.isFocused ? "#CCFFBB" : 0,
    },
  }),
  indicatorSeparator: (styles) => ({ display: "none" }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      fontSize: "14px",
      color: "#000",
    };
  },
  singleValue: provided => ({
    ...provided,
    overflow:"unset",
    
  })
};


const appStyles = {
  dropDown,
  appointmentDropDown,
  smallDropDown,
  switchStyle,
  selectDropDown,
  dopDownMenuOut,
  selectDropDownPrimary,
  selectDropDownPrimaryNoBackground,
  reportDropDown,
  reportDropDowntwo,
  customDropDownStyles,
  appointmentDropDownBig,
  color,
  languageDropDown
};

export default appStyles;
